/* eslint-disable */ import { memoEval, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const lynxProfessionalPowerBurnerComponents = [
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'default', true).withEntity('LynxProfessionalPowerBurner').attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/jms.glb',
            objectName: 'BURNER_POWER_LYNX_PROFESSIONAL_LPB',
            dimensionUnit: 'inch'
        })))
];

//# sourceMappingURL=lynx-professional-power-burner.js.map